/* eslint-disable no-return-await */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import TotalResultsMarketSharePage from 'src/pages/ReportsPages/ReportsBoard/MarketShareReportsPages/TotalResultsMarketSharePage'
import boardReportsService from 'src/services/boardReportsService'

const MarketShareTotalResult = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [totalResults, setTotalResults] = useState([])
  const [gTotalResults, setGTotalResults] = useState([])
  const [totalResultsSucategory, setTotalResultsSucategory] = useState([])
  const [gATotalResultsSucategory, setgATotalResultsSucategory] = useState([])
  const [gBTotalResultsSucategory, setgBTotalResultsSucategory] = useState([])

  const [totalResultsRegion, setTotalResultsRegion] = useState([])
  const [gATotalResultsRegion, setgATotalResultsRegion] = useState([])
  const [gBTotalResultsRegion, setgBTotalResultsRegion] = useState([])
  const [table10A, setTable10A] = useState([])
  const [table10B, setTable10B] = useState([])

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  const reloadTotalResults = async () => {
    const [
      totalResults,
      gTotalResults,
      totalResultsSucategory,
      gATotalResultsSucategory,
      gBTotalResultsSucategory,
      totalResultsRegion,
      gATotalResultsRegion,
      gBTotalResultsRegion,
      query10A,
      query10B,
    ] = await Promise.all([
      boardReportsService.getTotalMarketShare('7', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketShareGraphics('7', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketShare('8', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketShareGraphics('8a', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketShareGraphics('8b', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketShare('9', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketShareGraphics('9a', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketShareGraphics('9b', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketShare('10a', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketShare('10b', selectedDate.getFullYear()),
    ])
    setTotalResults(totalResults)
    setGTotalResults(gTotalResults)
    setTotalResultsSucategory(totalResultsSucategory)
    setgATotalResultsSucategory(gATotalResultsSucategory)
    setgBTotalResultsSucategory(gBTotalResultsSucategory)
    setTotalResultsRegion(totalResultsRegion)
    setgATotalResultsRegion(gATotalResultsRegion)
    setgBTotalResultsRegion(gBTotalResultsRegion)
    setTable10A(query10A)
    setTable10B(query10B)
  }

  useEffect(() => {
    reloadTotalResults()
  }, [selectedDate])

  return (
    <TotalResultsMarketSharePage
      table10A={table10A}
      table10B={table10B}
      gBTotalResultsSucategory={gBTotalResultsSucategory}
      gATotalResultsSucategory={gATotalResultsSucategory}
      handleDateChange={handleDateChange}
      totalResults={totalResults}
      totalResultsSucategory={totalResultsSucategory}
      gTotalResults={gTotalResults}
      selectedDate={selectedDate}
      totalResultsRegion={totalResultsRegion}
      gATotalResultsRegion={gATotalResultsRegion}
      gBTotalResultsRegion={gBTotalResultsRegion}
    />
  )
}

export default MarketShareTotalResult
